import { environment } from 'src/environments/environment';
import { HeaderInfoService } from '../../../servicios/header-info.service';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-pagina-lugares',
  templateUrl: './pagina-lugares.component.html',
  styleUrls: ['./pagina-lugares.component.scss']
})
export class PaginaLugaresComponent implements OnInit {

  environment = environment;

  public displayedColumns: any[] = [
    {
      nombre: 'nombreResidente',
      titulo: 'Nombre Ocupante',
      valueFieldName: 'user_name'
    },
    {
      nombre: 'area',
      titulo: 'Área',
      valueFieldName: 'area_name'
    },
    {
      nombre: 'apartamento',
      titulo: 'Unidad',
      valueFieldName: 'site_name'
    },
    {
      nombre: 'indicativo',
      titulo: 'Indicativo',
      valueFieldName: 'indicativo'
    },
    {
      nombre: 'celular',
      titulo: 'Celular',
      valueFieldName: 'celular'
    },
  ];

  constructor(private headerInfoService: HeaderInfoService) { }

  ngOnInit() {
    this.headerInfoService.cambiarTituloPagina("Lugares");
    this.headerInfoService.cambiarTituloTarjeta("¡Bienvenido a lugares!");
    this.headerInfoService.cambiarTextoTarjeta("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo.");
    // this.headerInfoService.cambiarImagenTarjeta('./../../../../assets/header/pagina-principal-lugares.svg');
  }

}
